<template>
    <!-- banner -->
    <section class="home-banner">
        <el-carousel height="978px">
            <!-- <el-carousel-item>
                <section class="carousel-item-content">
                    <div class="content-text">
                        <p>智慧人事，智慧管理</p>
                        <p>线上线下一体化人力资源管理解决方案</p>
                    </div>
                    <el-image style="width: 100%; height: 100%" :src="require(`${'@/assets/webImg/banner.jpg'}`)" fit="cover"></el-image>
                </section>
            </el-carousel-item> -->
            <el-carousel-item height="978px">
                <el-image style="width: 100%; height: 100%" :src="require(`${'@/assets/webImg/home/banner1.png'}`)" fit="cover"></el-image>
            </el-carousel-item>
        </el-carousel>
    </section>
</template>

<script>
export default {
	data() {
		return {

		}
	},

	computed: {
      
    },

	created() {

	},

    mounted() {
    },

    methods: {
    }
}
</script>

<style lang="scss">
/** banner */
.home-banner {
    position: relative;
    z-index: 1000;
    width: 100%;
    height: 978px;
    padding-top: 104px;
    .carousel-item-content {
        width: 100%;
        height: 100%;
        position: relative;
        .content-text {
            position: absolute;
            z-index: 1002;
            top: 307px;
            left: 225px;
            p:first-child {
                font-size: 60px;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 84px;
            }
            p:last-child {
                margin-top: 30px;
                font-size: 32px;
                color: #FFFFFF;
                line-height: 45px;
            }
        }
    }
}

</style>
